var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}},[_c('rect',{attrs:{"x":"4.5","y":"3.5","width":"8","height":"8","rx":"0.5","stroke":"currentColor"}}),_vm._v(" "),_c('rect',{attrs:{"x":"2.5","y":"5.5","width":"8","height":"8","rx":"0.5","fill":"white","stroke":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }